export { default } from './TimelineDot';
export type * from './TimelineDot';

export { default as timelineDotClasses } from './timelineDotClasses';
export * from './timelineDotClasses';
